import { Radio, type RadioProps } from 'antd';
import type { RadioRef } from 'antd/es/radio';
import { forwardRef, type ReactNode } from 'react';
import cn from 'classnames';
import styles from './radio.module.scss';

type Props = RadioProps & {
    size?: 'md' | 'lg';
    label?: ReactNode;
};

const AppRadioComponent = forwardRef<RadioRef, Props>(function AppRadio(
    { className, size = 'md', title, label, children, ...rest },
    ref
) {
    const content = label ?? title ?? children;

    return (
        <Radio
            {...rest}
            ref={ref}
            className={cn('app-radio', className)}
            rootClassName={cn(styles.root, styles[size])}
        >
            {content}
        </Radio>
    );
});

AppRadioComponent.displayName = 'AppRadio';

export const AppRadio = AppRadioComponent;
export default AppRadioComponent;
